import TableSkeleton from './table-skeleton';

export default function LivraisonTableSkeleton() {
    const columns = ['No Bon Livraison', 'Date', 'Station', 'Produit', 'Carte', 'Quantité', 'Total'];

    return <TableSkeleton rows={5} columns={columns} />;
}
